import { FaFilePdf } from 'react-icons/fa'

// Если фото загружено то отображается превью
const PreviewField = ({ file }) => {
    console.log("fileInstance:", file);

    if (!file) {
        return null;
    }

    if (typeof file === "string" && file.endsWith(".pdf")) {
        return (
            <div style={{ width: 100, height: 'auto', marginTop: "1rem" }}>
                <a href={file} target="_blank" rel="noopener noreferrer">
                    <FaFilePdf size={100} />
                </a>
            </div>
        )
    }

    if (file instanceof FileList && file.length > 0) {
        const firstFile = file[0];
        return (
            <div style={{ width: 100, height: 'auto', marginTop: "1rem" }}>
                <img src={URL.createObjectURL(firstFile)} alt="" />
            </div>
        )
    }

    return (
        <div style={{ width: 100, height: 'auto', marginTop: "1rem" }}>
            <img src={file} alt="" />
        </div>
    )
}

export const FileInput = ({ key, label, value, onChange }) => {
    return (
        <div key={key} className="flex flex-col field-file m-b-32">
            <div className="preview">
                <label>{label}</label>
                <PreviewField file={value} />
            </div>
            <div>
                <input
                    type="file"
                    id={key}
                    name={key}
                    onChange={(e) => {
                        // Do validation && display preview of selected image
                        console.log("onChange: file", { e, id: key, element: e.target });
                        // const file = document.querySelector(`#${f.key}`).files[0];
                        const file = e.target.files[0]
                        const max = 5 * 1000 * 1000; // 5MB
                        console.log("File:", file);
                        if (file && file.size > max) {
                            alert(
                                "Вы не можете загружать большие файлы! Пожалуйста используйте файл маленького размера"
                            );
                        }

                        // const fileReader = new FileReader();
                        // const previewNode = e.target.parentNode.parentNode.querySelector('.preview')
                        // if (!previewNode.querySelector('img')) {
                        //     const img = document.createElement('img')
                        //     const imgWrapper = document.createElement('div')
                        //     imgWrapper.style = 'width: 100px; height: auto; margin-top: 1rem;'
                        //     imgWrapper.appendChild(img)
                        //     previewNode.appendChild(imgWrapper)
                        // }

                        // const previewImage = previewNode.querySelector('img')

                        // fileReader.onload = event => {
                        //     previewImage.setAttribute('src', event.target.result);
                        // }
                        // fileReader.readAsDataURL(file);
                        onChange(e.target.files)
                    }}
                />
            </div>
        </div>
    )
}
